import React, { useState, useEffect } from 'react';
import qs from 'qs';
import { FormControl, Button, Typography, InputBase } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

export default function RequestPasswordReset() {
  const classes = useStyles();
  const queryString = (document.location.search || '').slice(1);
  const params = qs.parse(queryString);
  const [email, setEmail] = useState(params.email || '');
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const lang = document.documentElement.lang;
    i18n.changeLanguage(lang);
    moment.locale(lang);
  }, [i18n]);

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_reset_request']"
    );

    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <div />;
  }

  return (
    <div className={classes.container}>
      <Typography variant="h1">{t('Request Password Reset')}</Typography>
      <Typography variant="body1" className={classes.bodyText}>
        {t(
          'We’ll send you an email with instructions on how to reset your password.'
        )}
      </Typography>
      <FormControl variant="standard" fullWidth>
        <InputBase
          onKeyPress={handleKeyPress}
          id="email"
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t('Your email address')}
        />
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          type="submit"
          onClick={handleRequestPasswordClick}
        >
          {t('Send password reset link')}
        </Button>
      </FormControl>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  bodyText: {
    margin: theme.spacing(3, 0),
  },
  button: { marginTop: theme.spacing(5) },
  container: {
    maxWidth: 328,
    margin: '0 auto',
  },
}));
